import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import { SocketProvider } from './contexts/SocketContext';
import MigrationScreen from './components/MigrationScreen';
import { installFetchMigrationGuard } from './utils/migration';
import { installFetchClientBuildHeader } from './utils/clientBuild';
import { installTouchContextMenuGuard } from './utils/touchContextMenu';

import reportWebVitals from './reportWebVitals';


// ΠΡΙΝ από το πρώτο render: ο έλεγχος συνεδρίας στην εκκίνηση είναι από τα πρώτα
// αιτήματα, και αν ο οργανισμός έχει μεταφερθεί πρέπει να το πιάσουμε ήδη εκεί.
// Η κεφαλίδα build πρώτη, ώστε να τη στέλνει και ο έλεγχος συνεδρίας της
// εκκίνησης· ο φρουρός μεταφοράς τυλίγεται από πάνω και βλέπει την ίδια απάντηση.
installFetchClientBuildHeader();
installFetchMigrationGuard();

// Never let the mouse wheel change a number input's value. When the wheel scrolls over a
// FOCUSED number field we just blur it (so the page keeps scrolling and the value stays
// put) — keyboard entry only, matching the no-spinner-arrows rule in index.css.
document.addEventListener('wheel', (e) => {
  const el = document.activeElement as HTMLInputElement | null;
  if (el && el.tagName === 'INPUT' && el.type === 'number' && el === e.target) {
    el.blur();
  }
}, { passive: true });

// Οθόνες αφής: το παρατεταμένο άγγιγμα δεν ανοίγει το μενού των Windows (βλ. utils/touchContextMenu).
installTouchContextMenuGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
        {/* Πάνω από ΟΛΑ, και από τη σελίδα σύνδεσης — βλ. utils/migration.ts */}
        <MigrationScreen />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

